<template>
  <div class="app-consent-wrapper">
    <SimonModal
      :is-visible="showTermsInfoModal"
      @hide="showTermsInfoModal = false"
      id="terms-info-modal"
    >
      <span class="docM" v-html="termsInfoModalText"></span>
    </SimonModal>
    <div class="card-wrapper">
      <div class="card">
        <slot name="txtBefore">
          <p>Datenschutz & Einwilligungen</p>
        </slot>

        <b-form>
          <ChangeConsentWrapper :filter-consent-texts="consentTexts" :filter-consents="consents">
            <template v-for="slot in possibleChildSlotsFor('ChangeConsent')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </ChangeConsentWrapper>
        </b-form>

        <slot name="txtAfter"></slot>
      </div>
    </div>
  </div>
</template>
<script>

import ChangeConsentWrapper from './ChangeConsentWrapper.vue'
import extraData from '@/mixins/extraData'
import { mapGetters, mapMutations } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ConsentWrapper',
  data () {
    return {
      showTermsInfoModal: false,
      termsInfoModalText: ''
    }
  },
  components: {
    SimonModal,
    ChangeConsentWrapper
  },
  mounted () {
    window.consentWrapperTermsShowModal = (terms, part) => {
      const elem = document.getElementById(terms + '_' + part)
      this.termsInfoModalText = elem.outerHTML
      this.showTermsInfoModal = true
    }
  },
  methods: {
    ...mapMutations('consent', [
      'changeStep'
    ])
  },
  computed: {
    ...mapGetters('consent', [
      'getStep'
    ]),
    consentTexts: function () {
      return this.extraData?.consentTexts || []
    },
    consents: function () {
      return this.extraData?.consents || []
    }
  },
  mixins: [
    extraData()
  ]
}
</script>
